import { N0, N200 } from '@atlaskit/theme/colors';
import { getIsBundleBbJsw } from '@atlassiansox/bxpkit-core';
import styled from '@emotion/styled';
import React from 'react';
import { ContainerLayoutType } from '../../../../../model';
import { HeaderDevops, SideInfoDevops, Signup } from '../component';
import { FullWidth, ReducedRow } from '../styled';

export function LayoutDevops(props: ContainerLayoutType) {
  // Disable field progression for BB/JSW
  const fieldProgression = getIsBundleBbJsw(props?.productKeys) ? false : true;

  return (
    <FullWidth>
      <HeaderDevops {...props} />
      <ReducedRow>
        <FormWrapper>
          <ComponentWrapper className="wrapper-side-info">
            <SideInfoDevops {...props} />
          </ComponentWrapper>
          <ComponentWrapper>
            <div className="wrapper-signup">
              <Signup
                {...props}
                enableFieldProgression={fieldProgression}
                fadeOnDisable={true}
                popOverError={true}
                outlineOnFocus={true}
                showWarningIcon={true}
                hideCaptchaEula={true}
                enableResendEmail={true}
                enableCarouselEndCard={true}
              />
            </div>
            <div className="recaptcha-legal">
              This page is protected by reCAPTCHA and the Google Privacy Policy
              and Terms of Service apply.
            </div>
          </ComponentWrapper>
        </FormWrapper>
      </ReducedRow>
    </FullWidth>
  );
}

const FormWrapper = styled.div`
  z-index: 9;
  width: 100%%;
  margin: auto;
  display: flex;
  flex-direction: row;
  flex-flow: nowrap;
  padding: 0px 48px 48px 48px;

  @media only screen and (max-width: 800px) {
    box-sizing: border-box;
    flex-flow: row wrap;
    padding: 24px;
  }
`;

const ComponentWrapper = styled.div`
  width: 50%;

  @media only screen and (max-width: 800px) {
    width: 100%;
  }

  &.wrapper-side-info {
    padding: 0 48px 0 0;
    margin-top: -30px;

    @media only screen and (max-width: 800px) {
      display: none;
    }
  }

  .wrapper-signup {
    padding: 48px 96px;
    margin-top: -160px;
    background-color: ${N0};
    box-shadow: 0px 8px 16px rgba(9, 30, 66, 0.25),
      0px 0px 1px rgba(9, 30, 66, 0.31);
    border-radius: 3px;

    form {
      max-width: none;
    }

    @media only screen and (max-width: 1200px) {
      padding: 48px;
    }

    @media only screen and (max-width: 800px) {
      padding: 0px;
      margin-top: 0px;
      box-shadow: none;
    }
  }

  .recaptcha-legal {
    display: block;
    max-width: 296px;
    padding: 25px 0;
    margin: auto;
    text-align: center;
    font-family: Charlie Text, -apple-system, BlinkMacSystemFont, Segoe UI,
      Roboto, Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif;
    font-size: 12px;
    line-height: 18px;
    color: ${N200};

    @media only screen and (max-width: 800px) {
      padding: 50px 0 60px 0;
    }
  }
`;
